<!--
 * @Descripttion: 权限设置
 * @Author: zenghua.wang
 * @Date: 2021-12-29 15:25:59
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-30 09:30:00
-->
<template>
  <el-collapse-item :title="title">

    <el-form-item label="权限方式">
      <el-select
        v-model="data.option.authType"
        clearable
        placeholder="请选择"
      >
        <el-option
          v-for="item in authTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="角色选择">
      <vue-multiple-select
        :multiple-list="data.option.roleList"
        @multipleOpen="show=true"
      />

      <RoleSelect
        :visible.sync="show"
        :multiple="true"
        :backDatas="data.option.roleList"
        @onChecked="handleChecked"
      />
    </el-form-item>

  </el-collapse-item>
</template>

<script>
import { component } from '@/dragComponents/model/default.js'

import vueMultipleSelect from '@/dragComponents/components/vueMultipleSelect'
import { RoleSelect } from '@/framework/components/user'

export default {
  name: 'config-auth',
  components: {
    vueMultipleSelect,
    RoleSelect
  },
  inject: ['main', 'category'],
  props: {
    title: {
      type: String,
      default: '权限设置'
    },
    data: {
      type: [Array, Object]
    }
  },
  data() {
    return {
      authTypeList: component.authType,
      show: false
    }
  },
  methods: {
    handleChecked(roles) {
      this.$set(this.data.option, 'roleList', roles)
    }
  }
}
</script>
